window.addEventListener("load", function () {
	// ===== Share button: copy URL → toast =====
	const TOAST_ID = "ms-copy-toast";

	function ensureToast() {
		let toast = document.getElementById(TOAST_ID);
		if (toast) return toast;
		toast = document.createElement("div");
		toast.id = TOAST_ID;
		toast.className = "ms-copy-toast";
		document.body.appendChild(toast);
		return toast;
	}

	let hideTimer;
	function showToast() {
		const toast = ensureToast();
		clearTimeout(hideTimer);
		// reflow to restart animation if already showing
		toast.classList.remove("is-active");
		void toast.offsetWidth;
		toast.classList.add("is-active");
		hideTimer = setTimeout(function () {
			toast.classList.remove("is-active");
		}, 2000);
	}

	function copyText(text) {
		if (navigator.clipboard && window.isSecureContext) {
			return navigator.clipboard.writeText(text);
		}
		const ta = document.createElement("textarea");
		ta.value = text;
		ta.style.position = "fixed";
		ta.style.opacity = "0";
		document.body.appendChild(ta);
		ta.select();
		try {
			document.execCommand("copy");
		} catch (e) {}
		document.body.removeChild(ta);
		return Promise.resolve();
	}

	document.addEventListener("click", function (e) {
		const btn = e.target.closest(".post-card__btn--share");
		if (!btn) return;
		e.preventDefault();
		const url = btn.dataset.shareUrl || window.location.href;
		Promise.resolve(copyText(url)).then(showToast).catch(showToast);
	});
});
